import { on, select, selectAll, toggleClass, removeClass, addClass, setAttribute, getHeight, getScrollTop } from 'modules/dom'
import { map } from 'modules/utils'
import throttle from 'lodash.throttle'
import Stickyfill from 'stickyfilljs'

const body = document.body
const ACTIVATE_CLASS = 'slideout-activate'
const ACTIVATE_FORM_SEARCH_CLASS = 'form-search-activate'
const SHADOW_HEADER_CLASS = 'header-has-shadow'
const STICKY_HEADER_CLASS = 'is-fixed-header'
const wrapper = select('.js-wrapper')
const header = select('.js-header')
const slideout = select('.js-slideout')
const overlayEl = select('.js-slideout-overlay')
const closeHelloBar = select('.js-button-close')
const activateFormSearch = () => toggleClass(ACTIVATE_FORM_SEARCH_CLASS, body)
const deactivateFormSearch = () => removeClass(ACTIVATE_FORM_SEARCH_CLASS, body)

export default function (el) {
  if (header) {
    Stickyfill.forceSticky(header)
  }

  const setTopSlideOut = (value) => {
    if (value && slideout && overlayEl) {
      slideout.style.top = value + 'px'
      overlayEl.style.top = value + 'px'
    }
  }

  const activateSlideout = () => {
    if (header) {
      const headerPos = header.getBoundingClientRect()
      toggleClass(ACTIVATE_CLASS, body)
      if (slideout && overlayEl) {
        if (headerPos.top > 0) {
          setTopSlideOut(headerPos.top + headerPos.height)
        } else {
          toggleClass(STICKY_HEADER_CLASS, body)
          setTopSlideOut(headerPos.height)
        }
      }
    }
  }

  const slideoutToggle = select('[data-slideout-toggle]', el)
  if (slideoutToggle) {
    on('click', activateSlideout, slideoutToggle)
  }

  const formSearchToggle = select('[data-form-search-toggle]', el)
  if (formSearchToggle) {
    on('click', activateFormSearch, formSearchToggle)
  }

  const formSearchDeactivate = select('[data-form-search-deactivate]', el)
  if (formSearchDeactivate) {
    on('click', deactivateFormSearch, formSearchDeactivate)
  }

  const menuHasChildren = selectAll('.menu-item-has-children', el)
  menuHasChildren.map((menuItem, index) => {
    on('focus', function (e) {
      setAttribute('aria-expanded', true, menuItem )
    }, menuItem)
    on('blur', function (e) {
      setAttribute('aria-expanded', false, menuItem )
    }, menuItem)
  }, menuHasChildren)

  const menuIsChildren = selectAll('.menu-item-has-children>a', el)
  menuIsChildren.map((menuItem, index) => {
    on('focus', function (e) {
      setAttribute('aria-expanded', true, menuItem.parentNode )
    }, menuItem)
  }, menuIsChildren)

  // get all menu parent level-0
  const parentMenus = selectAll('.js-menu-item-parent', el)
  if (parentMenus.length > 0) {
    map((parentMenu) => {
      parentMenu.addEventListener('keydown', e => trappingKeyboardFocus(e, parentMenu))
    }, parentMenus)
  }
  const trappingKeyboardFocus = (e, parentMenu) => {
    setAttribute('aria-expanded', true, parentMenu)
    const focusableElements = [...parentMenu.querySelectorAll('a[href]')]
    if (focusableElements.length > 0) {
      const lastFocusableElement = focusableElements && focusableElements[focusableElements.length - 1]
      if (e.target === lastFocusableElement && e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault()
        setAttribute('aria-expanded', false, parentMenu)
      }
    }
  }

  // focus out last item menu set all parent menu expanded is false
  const lastMenuItem = select('.menu-item-has-children:last-child .menu-item:last-child > a', el)
  on('focusout', function (e) {
    const openMenu = selectAll('.menu-item[aria-expanded="true"]', el)
    openMenu.map((openMenuItem) => {
      setAttribute('aria-expanded', false, openMenuItem )
    }, openMenu)
  }, lastMenuItem)

  const helloBar = select('.hello-bar')

  const stickyHeader = () => {

    if (helloBar) {
      const helloBarHeight = getHeight(helloBar)
      if (getScrollTop(wrapper) > helloBarHeight) {
          addClass(STICKY_HEADER_CLASS, body)
          if (slideout) {
            slideout.style.top = ''
          }
      } else {
          removeClass(STICKY_HEADER_CLASS, header)
          if (slideout) {
            slideout.style.top = getHeight(helloBar) + 'px'
          }
      }
    } else {
      if (getScrollTop(wrapper) > 0) {
          addClass(STICKY_HEADER_CLASS, header)
      } else {
          removeClass(STICKY_HEADER_CLASS, header)
      }
    }
  }

  const getTopWhenNoHelloBar = () => {
    if (slideout) {
      slideout.style.top = 0
    }
  }

  if (closeHelloBar) {
    on('click', getTopWhenNoHelloBar, closeHelloBar)
  }

  on('scroll', throttle(stickyHeader), wrapper)

  on('load', () => {
    addClass(SHADOW_HEADER_CLASS, body)
    if (helloBar) {
      if (slideout) {
        slideout.style.top = getHeight(helloBar) + 'px'
      }
    }

    const hash = window.location.hash
    if (hash !== '') {
      setTimeout(() => {
        const id = hash.replace('#', '')
        const element = document.getElementById(id)
        if (element && element.scrollIntoView) {
          element.scrollIntoView()
        }
      }, 0)
    }
  }, window)
}
